<template>
    <div>
        <nav-bar :key="1"></nav-bar>
        <div class="content">
            <nav-left-bar :active="1" :key="1"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div class="tc">平台简介</div>
                </div>
                <div class="intrduce" v-html="brief.content">
                    
                </div>
                <!-- <img src="../assets/icon/icon_intrduce.png" alt="" class="in" /> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "mine",
    data() {
        return {
            information: {},
            brief:{}
        };
    },
    methods: {
       
        /**平台简介 */
        intrduce() {
            this.$post("/api/person/about", "")
                .then(res => {
                    if(res.code==1){
                        this.brief=res.data
                    }
                })
                .catch(err => {});
        }
    },
    mounted() {
        this.intrduce();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            display: flex;
            align-items: center;
            img {
                width: 5px;
                height: 24px;
            }
            .tc {
                font-size: 24px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                padding-left: 13px;
            }
        }
        .intrduce {
            width: 770px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #333333;
            line-height: 25px;
            padding: 51px 0 0 32px;
            img{
                width: 770px !important;
            }
        }
        .in {
            width: 770px;
            height: 200px;
            margin-top: 23px;
        }
    }
}
</style>
